import { render, staticRenderFns } from "./IntersectionTypeEdit.vue?vue&type=template&id=40defaf5"
import script from "./IntersectionTypeEdit.vue?vue&type=script&lang=js"
export * from "./IntersectionTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports